module.exports = __webpack_public_path__ + "static/media/sign_up_2.a9eb5bae.png";